import C1 from "../Images/Chairs/C1.jpg";
import C11 from "../Images/Chairs/C11.jpg";
import C12 from "../Images/Chairs/C12.jpg";
import C13 from "../Images/Chairs/C13.jpg";
import C14 from "../Images/Chairs/C14.jpg";
import C2 from "../Images/Chairs/C2.jpg";
import C21 from "../Images/Chairs/C21.jpg";
import C22 from "../Images/Chairs/C22.jpg";
import C23 from "../Images/Chairs/C23.jpg";
import C24 from "../Images/Chairs/C24.jpg";
import C3 from "../Images/Chairs/C3.jpg";
import C31 from "../Images/Chairs/C31.jpg";
import C32 from "../Images/Chairs/C32.jpg";
import C33 from "../Images/Chairs/C33.jpg";
import C34 from "../Images/Chairs/C34.jpg";
import C4 from "../Images/Chairs/C4.jpg";
import C41 from "../Images/Chairs/C41.jpg";
import C42 from "../Images/Chairs/C42.jpg";
import C43 from "../Images/Chairs/C43.jpg";
import C44 from "../Images/Chairs/C44.jpg";
import C5 from "../Images/Chairs/C5.jpg";
import C51 from "../Images/Chairs/C51.jpg";
import C52 from "../Images/Chairs/C52.jpg";
import C53 from "../Images/Chairs/C53.jpg";
import C54 from "../Images/Chairs/C54.jpg";
import C6 from "../Images/Chairs/C6.jpg";
import C61 from "../Images/Chairs/C61.jpg";
import C62 from "../Images/Chairs/C62.jpg";
import C63 from "../Images/Chairs/C63.jpg";
import C64 from "../Images/Chairs/C64.jpg";
import C7 from "../Images/Best seller/b1.webp";
//headPhones
import H1 from "../Images/Headphones/H1.webp";
import H11 from "../Images/Headphones/H11.webp";
import H12 from "../Images/Headphones/H12.webp";
import H13 from "../Images/Headphones/H13.webp";
import H14 from "../Images/Headphones/H14.webp";
import H2 from "../Images/Headphones/H2.jpg";
import H21 from "../Images/Headphones/H21.jpg";
import H22 from "../Images/Headphones/H22.jpg";
import H23 from "../Images/Headphones/H23.jpg";
import H24 from "../Images/Headphones/H24.jpg";
import H3 from "../Images/Headphones/H3.jpg";
import H31 from "../Images/Headphones/H31.jpg";
import H32 from "../Images/Headphones/H32.jpg";
import H33 from "../Images/Headphones/H33.jpg";
import H4 from "../Images/Headphones/H4.jpg";
import H41 from "../Images/Headphones/H41.webp";
import H42 from "../Images/Headphones/H42.webp";
import H43 from "../Images/Headphones/H43.webp";
import H44 from "../Images/Headphones/H44.webp";
//Mouse
import M1 from "../Images/Mouse/M1.jpg";
import M11 from "../Images/Mouse/M11.jpg";
import M12 from "../Images/Mouse/M12.jpg";
import M13 from "../Images/Mouse/M13.jpg";
import M14 from "../Images/Mouse/M14.jpg";
import M2 from "../Images/Mouse/M2.jpg";
import M21 from "../Images/Mouse/M21.jpg";
import M22 from "../Images/Mouse/M22.jpg";
import M23 from "../Images/Mouse/M23.jpg";
import M24 from "../Images/Mouse/M24.jpg";
import M3 from "../Images/Mouse/M3.jpg";
import M31 from "../Images/Mouse/M31.jpg";
import M32 from "../Images/Mouse/M32.jpg";
import M33 from "../Images/Mouse/M33.jpg";
import M34 from "../Images/Mouse/M34.jpg";
import M4 from "../Images/Mouse/M4.jpg";
import M41 from "../Images/Mouse/M41.jpg";
import M42 from "../Images/Mouse/M42.jpg";
import M43 from "../Images/Mouse/M43.webp";
import M44 from "../Images/Mouse/M44.webp";
// MousePad
import MP1 from "../Images/Mouse/MP1.webp";
import MP11 from "../Images/Mouse/MP11.jpg";
import MP12 from "../Images/Mouse/MP12.jpg";
import MP13 from "../Images/Mouse/MP13.jpg";
import MP14 from "../Images/Mouse/MP14.jpg";
import MP2 from "../Images/Mouse/MP2.webp";
import MP21 from "../Images/Mouse/MP21.jpg";
import MP22 from "../Images/Mouse/MP22.jpg";
import MP23 from "../Images/Mouse/MP23.jpg";
import MP24 from "../Images/Mouse/MP24.jpg";
//Keyboard
import K1 from "../Images/KeyBoards/K1.webp";
import K11 from "../Images/KeyBoards/K11.webp";
import K12 from "../Images/KeyBoards/K12.webp";
import K13 from "../Images/KeyBoards/K13.webp";
import K14 from "../Images/KeyBoards/K14.webp";
import K2 from "../Images/KeyBoards/K2.webp";
import K21 from "../Images/KeyBoards/K21.webp";
import K22 from "../Images/KeyBoards/K22.webp";
import K23 from "../Images/KeyBoards/K23.webp";
import K24 from "../Images/KeyBoards/K24.webp";
import K3 from "../Images/KeyBoards/K3.webp";
import K31 from "../Images/KeyBoards/K31.webp";
import K32 from "../Images/KeyBoards/K32.webp";
import K33 from "../Images/KeyBoards/K33.webp";
import K34 from "../Images/KeyBoards/K34.webp";
import K4 from "../Images/KeyBoards/K4.webp";
import K41 from "../Images/KeyBoards/K41.webp";
import K42 from "../Images/KeyBoards/K42.webp";
import K43 from "../Images/KeyBoards/K43.webp";
import K44 from "../Images/KeyBoards/K44.webp";
import CO1 from "../Images/console/CO1.webp";
import CO2 from "../Images/console/CO2.jpg";
import CO21 from "../Images/console/CO21.jpg";
import CO22 from "../Images/console/CO22.jpg";
import CO23 from "../Images/console/CO23.jpg";
import CO24 from "../Images/console/CO24.jpg";
import CO3 from "../Images/console/CO3.webp";

import CO4 from "../Images/console/CO4.jpg";
import CO41 from "../Images/console/CO41.jpg";
import CO42 from "../Images/console/CO42.jpg";
import CO43 from "../Images/console/CO43.webp";
import CO44 from "../Images/console/CO44.png";

//controllers
import X1 from "../Images/Controller/X1.jpg";
import X11 from "../Images/Controller/X11.jpg";
import X12 from "../Images/Controller/X12.jpg";
import X13 from "../Images/Controller/X13.jpg";
import X14 from "../Images/Controller/X14.jpg";
import X2 from "../Images/Controller/X2.jpg";
import X21 from "../Images/Controller/X21.jpg";
import X22 from "../Images/Controller/X22.jpg";
import X23 from "../Images/Controller/X23.jpg";
import X24 from "../Images/Controller/X24.jpg";
import X3 from "../Images/Controller/X3.jpg";
import X31 from "../Images/Controller/X31.jpg";
import X32 from "../Images/Controller/X32.jpg";
import X33 from "../Images/Controller/X33.jpg";
import X34 from "../Images/Controller/X34.jpg";
import X4 from "../Images/Controller/X4.jpg";
import X41 from "../Images/Controller/X41.jpg";
import X42 from "../Images/Controller/X42.jpg";
import X43 from "../Images/Controller/X43.jpg";
import X44 from "../Images/Controller/X44.jpg";

export const items = [
  {
    id: 1,
    pname: "JET GAMING HEADPHONE",
    img: H1,
    img2: H11,
    img3: H12,
    img4: H13,
    img5: H14,
    img11:[H11, H12, H13, H14],
    name: "Zebronics Jet Premium Wired Gaming On Ear Headphone with LED Light for earcups",
    price: "₹790",
  },
  {
    id: 2,
    img: H2,
    img2: H21,
    img3: H22,
    img4: H23,
    img5: H24,
    name: "JBL Quantum 100 Wired Over Ear Gaming Headphones with Mic",
    price: "₹2,099",
  },
  {
    id: 3,
    img: H3,
    img2: H31,
    img3: H32,
    img4: H33,
    img5: H31,
    name: "Razer BlackShark V2 X - White ",
    price: "₹4,599",
  },
  {
    id: 4,
    img: H4,
    img2: H41,
    img3: H42,
    img4: H43,
    img5: H44,
    name: "HyperX Cloud Stinger 2 Core Essential PC Gaming Wired Headset",
    price: "₹3,599",
  },
  {
    id: 5,
    img: M1,
    img2: M11,
    img3: M12,
    img4: M13,
    img5: M14,
    name: "Logitech G502 X Lightspeed Plus Wireless RGB Gaming Mouse",
    price: "₹14,000",
  },
  {
    id: 6,
    img: M2,
    img2: M21,
    img3: M22,
    img4: M23,
    img5: M24,
    name: "Logitech G502 Lightspeed Wireless Gaming Mouse",
    price: "₹11,095",
  },
  {
    id: 7,
    img: M3,
    img2: M31,
    img3: M32,
    img4: M33,
    img5: M34,
    name: "Logitech G304 Lightspeed Wireless Gaming Mouse",
    price: "₹2,299",
  },
  {
    id: 8,
    img: M4,
    img2: M41,
    img3: M42,
    img4: M43,
    img5: M44,
    name: "Logitech G PRO Wireless Gaming Mouse",
    price: "₹9,999",
  },
  {
    id: 9,
    img: MP1,
    img2: MP11,
    img3: MP12,
    img4: MP13,
    img5: MP14,
    name: "FIRESTORM",
    price: "₹329",
  },
  {
    id: 10,
    img: K1,
    img2: K11,
    img3: K12,
    img4: K13,
    img5: K14,
    name: "MAX NINJA 200 WIRELESS GAMING KEYBOARD (MECHANICAL)",
    price: "₹ 3,999.00",
  },
  {
    id: 11,
    img: K2,
    img2: K21,
    img3: K22,
    img4: K23,
    img5: K24,
    name: "NITRO PRO WIRED GAMING KEYBOARD (MECHANICAL)",
    price: "₹ 2,499.00",
  },
  {
    id: 12,
    img: MP2,
    img2: MP21,
    img3: MP22,
    img4: MP23,
    img5: MP24,
    name: "BLAZE XL RGB (SANTANU EDITION)",
    price: "₹ 1,299.00",
  },
  {
    id: 13,
    img: K3,
    img2: K31,
    img3: K32,
    img4: K33,
    img5: K34,
    name: "MAX CHROMA WIRED GAMING KEYBOARD (MECHANICAL)",
    price: "₹ 3,799.00",
  },
  {
    id: 14,
    img: K4,
    img2: K41,
    img3: K42,
    img4: K43,
    img5: K44,
    name: "MAX NINJA WIRELESS GAMING KEYBOARD (MECHANICAL)",
    price: "₹ 3,699.00",
  },
  {
    id:29,
    img: C7,
    name: "Mach Gaming Chair",
    price: "₹12000",
  },
  {
    id: 15,
    img: C1,
    img2: C11,
    img3: C12,
    img4: C13,
    img5: C14,
    name: "Green Soul® Ghost Ergonomic Gaming Chair",
    price: "₹16,999",
  },
  {
    id: 16,
    img: C2,
    img2: C21,
    img3: C22,
    img4: C23,
    img5: C24,
    name: "Savya Home Snipe Gaming Chair with Adjustable Headrest & Lumbar Support",
    price: "₹7,569",
  },
  {
    id: 17,
    img: C3,
    img2: C31,
    img3: C32,
    img4: C33,
    img5: C34,
    name: "Da URBAN® High Back Mesh Ergonomic",
    price: "₹6,999",
  },
  {
    id: 18,
    img: C4,
    img2: C41,
    img3: C42,
    img4: C43,
    img5: C44,
    name: "SAVYA HOME Apollo High Back Ergonomic Chair ",
    price: "₹6,459",
  },
  {
    id: 19,
    img: C5,
    img2: C51,
    img3: C52,
    img4: C53,
    img5: C54,
    name: "Green Soul® Raptor 2.0 Racing Edition Ergonomic Gaming Chair with Premium PU Leather",
    price: "₹13,999",
  },
  {
    id: 20,
    img: C6,
    img2: C61,
    img3: C62,
    img4: C63,
    img5: C64,
    name: "Green Soul® Crest Premium High Back/Fiction Multi-Functional Ergonomic Gaming Chair ",
    price: "₹9,999",
  },
  // { id: 21, img: CO1, name: "Gameflow Black", price: "₹35,000" },
  {
    id: 22,
    img: CO2,
    img2: CO21,
    img3: CO22,
    img4: CO23,
    img5: CO24,
    name: "Xbox Series X",
    price: "₹49,185 ",
  },
  { id: 23, img: CO3, name: "Veritas VR Set", price: "₹12,599" },
  {
    id: 24,
    img: CO4,
    img2: CO41,
    img3: CO42,
    img4: CO43,
    img5: CO44,
    name: "PS5",
    price: "₹45,049",
  },
  {
    id: 25,
    img: X1,
    img2: X11,
    img3: X12,
    img4: X13,
    img5: X14,
    name: "Ghost",
    price: "₹1299",
  },
  {
    id: 26,
    img: X2,
    img2: X21,
    img3: X22,
    img4: X23,
    img5: X24,
    name: "Raptor",
    price: "₹5099",
  },
  {
    id: 27,
    img: X3,
    img2: X31,
    img3: X32,
    img4: X33,
    img5: X34,
    name: "Fint",
    price: "₹1199",
  },
  {
    id: 28,
    img: X4,
    img2: X41,
    img3: X42,
    img4: X43,
    img5: X44,
    name: "Wave",
    price: "₹2199",
  },
];
